module.exports = __webpack_public_path__ + "img/eat-right.ba7cc526.svg";